export var Steps = {
  baseStyle: {
    step: {
      bg: 'grey.250',
      borderBottomColor: 'grey.300',
      color: 'grey.980',
      px: 6,
      _first: {
        borderTopLeftRadius: 'none'
      },
      _last: {
        borderTopRightRadius: 'none'
      },
      _hover: {
        bg: 'blue.1140',
        color: 'grey.980'
      },
      _active: {
        color: 'grey.980'
      },
      _focusVisible: {
        bg: 'yellow.200',
        color: 'black',
        outline: 'none',
        boxShadow: 'none'
      },
      _disabled: {
        _hover: {
          cursor: 'default',
          bg: 'grey.250',
          color: 'grey.980'
        }
      }
    }
  },
  variants: {
    active: {
      step: {
        borderBottomColor: 'red.500',
        _hover: {
          cursor: 'default',
          color: 'grey.980',
          bg: 'grey.250'
        },
        _active: {
          color: 'grey.980',
          bg: 'grey.250'
        }
      }
    },
    completed: {
      step: {
        color: 'black',
        borderBottomColor: 'grey.950'
      }
    }
  }
};